module.exports = __webpack_public_path__ + "img/tap_deck_header.15fa538a.png";